//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useState } from 'react';
import { Dialog } from '@/components/_common';
import { TextField } from '@mui/material';
import { editSavedSearch } from '@/redux/slices/authSlice';
import { selectSavedSearches } from '@/redux/selectors/authSelectors';
import { useToast } from '../Toast';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const SavedSearchEdit = ({ savedSearchName, handleClose }) => {
  const [newName, setNewName] = useState(savedSearchName);
  const [hasError, setHasError] = useState(false);
  const savedSearches = useAppSelector(selectSavedSearches);
  const dispatch = useAppDispatch();
  const { success, error } = useToast();
  const history = useHistory();
  const location = useLocation();

  const handleConfirm = (e) => {
    e && e.preventDefault();
    const duplicateName = !!savedSearches.filter((ss) => ss.name.toLowerCase() === newName.toLowerCase()).length;
    if (duplicateName) {
      setHasError(true);
      error(`There is already a saved search named "${newName}".`);
    } else {
      dispatch(editSavedSearch({ previousName: savedSearchName, newName }))
        .unwrap()
        .then(() => {
          handleClose();
          success('Renamed saved search!');
          const searchParams = new URLSearchParams(location.search);
          searchParams.set('appliedSearchName', newName);
          history.push({ ...location, search: searchParams.toString() });
        })
        .catch((err) => {
          console.log(err);
          error(`There was a problem saving "${newName}".`);
        });
    }
  };

  const handleChange = (e) => {
    setNewName(e.target.value);
    setHasError(false);
  };

  return (
    <Dialog open={!!savedSearchName} title={`Rename "${savedSearchName}"`} onSubmit={handleConfirm} onCancel={handleClose}>
      <form noValidate autoComplete="off" onSubmit={handleConfirm}>
        <TextField
          id="name-search"
          error={hasError}
          label="Name your search"
          variant="filled"
          fullWidth
          value={newName}
          onChange={handleChange}
          autoFocus
        />
      </form>
    </Dialog>
  );
};

export default SavedSearchEdit;
